import React, { useEffect, useState } from 'react'
import ContentHeader from '../../../Layout/ContentHeader'
import Box from '../../../Global/Box'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import * as Yup from 'yup'
import InputController from '../../../Global/InputController'
import { useHistory, useParams } from 'react-router-dom'
import PreviewFormField from '../Forms/componets/previewForm/PreviewFormField'
import { useMutation, useQuery } from '@apollo/client'
import {
  CREATE_HUMAN_RESOURCES,
  GET_HUMAN_RESOURCE_BY_ID,
  UPDATE_HUMAN_RESOURCES,
} from '../../../../graphql/Catalog/HumanResources/humanResources'
import { DELETE_HUMAN_RESOURCES_ATTACHMENT_BY_ID } from '../../../../graphql/Catalog/HumanResources/humanResourcesAttachment'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'

const HumanResourcesNew = () => {
  const MySwal = withReactContent(Swal)
  const sizeMaxFile = 8 // EXPRESADO EN MB.
  const extensions_allowed_image = ['png', 'jpg']
  let imageWidth = 500
  let imageHeight = 440
  let flagKeepImageSize = false
  // ----------- HOOKS -----------------
  const { id: _id, show } = useParams()
  const { showLoading, hideLoading } = useLoading()
  const history = useHistory()
  const [dataHumanResources, setDataHumanResources] = useState({
    photograph: {
      id: null,
      url: null,
    },
    attachments: [],
  })

  // ----------- SCHEMAS ----------------
  const validationSchema = Yup.object().shape({
    photograph: Yup.array().required('Campo requerido').nullable(),
    name: Yup.string().trim().required('Campo requerido'),
    last_name: Yup.string().trim().required('Campo requerido'),
    attachments: Yup.array().required('Campo requerido').nullable(),
  })

  const validationSchemaEdit = Yup.object().shape({
    photograph: Yup.array().nullable(),
    name: Yup.string().trim().required('Campo requerido'),
    last_name: Yup.string().trim().required('Campo requerido'),
    attachments: Yup.array().nullable(),
  })

  const {
    methods,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(_id ? validationSchemaEdit : validationSchema),
  })
  // ----------- QUERIES AND MUTATIONS ---------
  const {
    data,
    loading,
    error,
    refetch: refetchResources,
  } = useQuery(GET_HUMAN_RESOURCE_BY_ID, {
    variables: {
      id: parseInt(_id || 0),
    },
  })
  const [CreateHumanResources] = useMutation(CREATE_HUMAN_RESOURCES)
  const [UpdateHumanResources] = useMutation(UPDATE_HUMAN_RESOURCES)
  const [DeleteAttachment] = useMutation(
    DELETE_HUMAN_RESOURCES_ATTACHMENT_BY_ID
  )

  // ----------- USEEFFECTS -------------
  useEffect(() => {
    if (_id && !loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      if (data) {
        const { name, last_name, photographFile, HumanResourcesToAttachments } =
          data?.getHumanResourceById
        let attachments = []
        HumanResourcesToAttachments?.map((attachment) => {
          const { url } = attachment?.attachmentFile
          attachments.push({
            id: attachment?.id,
            url,
          })
        })
        //Save Images
        setDataHumanResources({
          photograph: {
            id: photographFile?.id,
            url: photographFile?.url,
          },
          attachments,
        })
        const dataFormated = {
          name,
          last_name,
        }
        reset(dataFormated)
      }
    }
  }, [data, loading, error])
  // ----------- FUNCTIONS --------------
  const onSubmit = async (Data) => {
    showLoading()
    try {
      const { photograph, name, last_name, attachments } = Data

      if (photograph) {
        if (photograph[0].size / 1048576 > sizeMaxFile)
          return toastSweetAlert({
            mode: 'error',
            message: `La fotografía no puede superar los ${sizeMaxFile}MB`,
          })
      }
      if (attachments)
        for (const attachment of attachments) {
          if (attachment.size / 1048576 > sizeMaxFile)
            return toastSweetAlert({
              mode: 'error',
              message: `El archivo ${attachment.name} no puede superar los ${sizeMaxFile}MB`,
            })
        }

      const input = {
        photograph: photograph ? photograph[0] : null,
        name,
        last_name,
        attachments,
      }

      if (_id) {
        await UpdateHumanResources({
          variables: {
            id: parseInt(_id),
            input,
          },
        })
      } else {
        await CreateHumanResources({
          variables: {
            input,
          },
        })
      }
      reset()
      refetchResources()
      return toastSweetAlert(
        {
          mode: 'ok',
          message: `Usuario ${_id ? 'creado' : 'actualizado'}  correctamente`,
        },
        history.push('/humanResources')
      )
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  const handleDeleteAttachment = async (id) => {
    if (dataHumanResources?.attachments?.length === 1)
      return toastSweetAlert({
        mode: 'error',
        message: 'Debe tener al menos un documento',
      })
    MySwal.fire({
      showCloseButton: true,
      icon: 'warning',
      title: '¿Estas seguro de eliminar el documento?',
      html: (
        <>
          <div className="message-container">Esta accion es permanente</div>
        </>
      ),
      allowOutsideClick: false,
      buttonsStyling: false,
      showDenyButton: true,
      confirmButtonText: 'Aceptar',
      denyButtonText: 'Cancelar',
      reverseButtons: true,
      customClass: {
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-orange',
        denyButton: 'btn StandarModalCancelButtonLogOut',
        footer: 'btn StandarModalFooterLogOut',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        showLoading()
        try {
          const res = await DeleteAttachment({
            variables: {
              id,
            },
          })
          if (res) {
            // Quitar el attachment eliminado del estado local
            setDataHumanResources((prev) => ({
              ...prev,
              attachments: prev.attachments.filter((item) => item.id !== id),
            }))
            // let newAttachments = dataHumanResources?.attachments
            // newAttachments.filter((item) => item?.id !== id)
            // setDataHumanResources({
            //   ...dataHumanResources,
            //   attachments: newAttachments,
            // })
            return toastSweetAlert({
              mode: 'ok',
              message: 'Se elimino el archivo correctamente',
            })
          } else
            return toastSweetAlert({
              mode: 'error',
              message:
                'No se pudo eliminar el archivo, intentelo en otro momento',
            })
        } catch (error) {
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        } finally {
          hideLoading()
        }
      }
    })
  }

  const handleModalImage = (url) => {
    let resetImageSize = () => {
      imageWidth = 500
      imageHeight = 440
    }

    MySwal.fire({
      html: `
      <button id="increase-size-btn" class="btn btn-orange" style="margin-bottom:10px;">
      Aumentar tamaño
      </button>
      <img src="${url}" style="display:block;margin:auto;width:${imageWidth}px;height:${imageHeight}px;" />
      `,
      didOpen: () => {
        const btn = document.getElementById('increase-size-btn')
        if (btn) {
          btn.onclick = () => {
            imageWidth = imageWidth + 300
            imageHeight = imageHeight + 300
            flagKeepImageSize = true
            MySwal.close()
            handleModalImage(url)
          }
        }
      },
      willClose: () => {
        if (!flagKeepImageSize) resetImageSize()
        else flagKeepImageSize = false
      },
      width: imageWidth + 40,
      heightAuto: false,
      customClass: {
        popup: '',
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-orange',
        denyButton: 'btn StandarModalCancelButtonLogOut',
        footer: 'btn StandarModalFooterLogOut',
      },
      confirmButtonText: 'Aceptar',
    })
  }

  return (
    <>
      <ContentHeader
        title=""
        titleContent={
          <div className="col-12 col-sm-6">
            <h1 className="header-title">
              {_id ? (show ? 'Usuario' : 'Nuevo usuario') : 'Editar usuario'}
            </h1>
          </div>
        }
        breadcrumb=""
        windowTitle={''}
      />
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            withCard
            clasCard="card human-resources-new"
            contentHeader={
              <>
                <h3 className="card-title pl-3 mt-0">Detalles del usuario</h3>
              </>
            }
            classNameHeader="card-header p-0"
            btnRedPath="/humanResources"
            btnRedTxt="Cancelar"
            errors={errors}
            btnSubmit={show ? false : _id ? 'Actualizar' : 'Guardar'}
            content={
              <div className="row mb-3">
                <div className="col-12">
                  {!show && (
                    <InputController
                      label="Fotografía"
                      name="photograph"
                      inputType="attachment"
                      allowedFileTypes={extensions_allowed_image}
                      control={control}
                      maxFiles={1}
                      newDropAttachment={true}
                      readOnly={show}
                    />
                  )}
                  {_id && dataHumanResources?.photograph?.url && (
                    <div className="photograph-container">
                      <span>Fotografía</span> <br />
                      <img
                        src={dataHumanResources?.photograph?.url}
                        alt={`photograph${dataHumanResources?.photograph?.id}`}
                        onClick={() =>
                          handleModalImage(dataHumanResources?.photograph?.url)
                        }
                      />
                    </div>
                  )}
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <InputController
                    label="Nombre"
                    name="name"
                    type="text"
                    placeholder="Escribe un nombre"
                    control={control}
                    readOnly={show}
                  />
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <InputController
                    label="Apellidos"
                    name="last_name"
                    type="text"
                    placeholder="Escribe un apellido"
                    control={control}
                    readOnly={show}
                  />
                </div>
                <div className="col-12">
                  {!show && (
                    <InputController
                      label="Documentos"
                      name="attachments"
                      inputType="attachment"
                      allowedFileTypes={extensions_allowed_image}
                      control={control}
                      maxFiles={5}
                      // changeAction={(e) => onChangeFileImg(e, true)}
                      newDropAttachment={true}
                      readOnly={show}
                    />
                  )}
                  {_id && dataHumanResources?.attachments && (
                    <>
                      <div className="mt-3">
                        <span>Documentos</span> <br />
                      </div>
                      <div className="attachment-container">
                        {dataHumanResources?.attachments?.map((attachment) => (
                          <div className="attachment-item" key={attachment.id}>
                            <div>
                              <img
                                src={attachment?.url}
                                alt={`attachment${attachment.id}`}
                                onClick={() => handleModalImage(attachment.url)}
                              />
                            </div>
                            <div>
                              {!show && (
                                <i
                                  onClick={() =>
                                    handleDeleteAttachment(attachment.id)
                                  }
                                  className="fas fa-trash"
                                />
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default HumanResourcesNew
